import { allThrusterMetricNames } from '@shared_types/metrics/thruster_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_THRUSTER, UPDATE_THRUSTER } from '../actions'

const initialState = initializeMetrics(allThrusterMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_THRUSTER || type === UPDATE_THRUSTER) {
    console.log('init thruster', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
